import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from "react-phone-input-2";
import { ChevronRight } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { updateSponsorNetworkDetails } from "../../../../containers/actions/netwrokActions";
import { State } from "country-state-city";

const useStyles = makeStyles((theme) => ({
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "80%",
    marginTop: "8px",
  },
  required: {
    color: "red",
    marginLeft: "4px",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
}));

const SponsorDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();  const {
    sponsorDetails,
    adminDetails,
    handleSponsorNameChange,
    handleSponsorNameBlur,
    handleSponsorShortcutNameChange,
    handleSponsorShortcutNameBlur,
    handleCountryChange,
    handleStateChange,
    handleCityChange,
    handlePostCodeChange,
    handlePostCodeBlur,
    handleStreetAddress1Change,
    handleStreetAddress1Blur,
    handleStreetAddress2Change,
    handleStreetAddress2Blur,
    userStatusesData,
    handleStatusChange,
    Country,
    errors,
    handleFullNameChange,
    handleFullNameBlur,
    handleEmailAddressChange,
    handleEmailAddressBlur,
    //handlePhoneChange,
    handleNext,
    existingSponsorFlow,
    rowData,
    setSponsorDetails,
    isEditMode,
    sponsorDetailsLoading,
  } = props;
  const {
    sponsorName,
    sponsorNameShortcut,
    orgCode,
    selectedCountry,
    states,
    selectedState,
    cities,
    selectedCity,
    postCode,
    streetAddress1,
    streetAddress2,
    selectedStatus,
  } = sponsorDetails;

  const handlePhoneChange = (value, country) => {
    if (props.handlePhoneChange) {
      props.handlePhoneChange(value, country);
    }
  };

  const { fullName, emailAddress, countryCode } = adminDetails;

  const requiredFields = [
    { value: sponsorDetails.sponsorName, error: errors.sponsorName },
  { value: sponsorDetails.sponsorNameShortcut, error: errors.sponsorNameShortcut },
    { value: sponsorDetails.selectedCountry, error: errors.selectedCountry },
    { value: sponsorDetails.selectedState, error: errors.selectedState },
    { value: sponsorDetails.selectedCity, error: errors.selectedCity },
    { value: sponsorDetails.postCode, error: errors.postCode },
    { value: sponsorDetails.streetAddress1, error: errors.streetAddress1 },
    { value: sponsorDetails.selectedStatus, error: errors.selectedStatus },
    { value: sponsorDetails.streetAddress2, error: errors.streetAddress2 },
    { value: adminDetails.fullName, error: errors.fullName },
    { value: adminDetails.emailAddress, error: errors.emailAddress },
    { value: adminDetails.phone, error: errors.phone },
  ];

  console.log("adminDetails",adminDetails);
  console.log("sponsorDetails",sponsorDetails)
  // Store all countries in a variable to avoid duplicate calls
  const allCountries = Country.getAllCountries();

  // Helper to get isoCode from country name
  function getCountryIsoCodeByName(countryName) {
    const countryObj = allCountries.find((c) => c.name === countryName);
    return countryObj ? countryObj.isoCode : countryName; // fallback to original if not found
  }

  // Ensure selectedCountry is always isoCode and always controlled
  let selectedCountryIso = selectedCountry || "";
  if (selectedCountry) {
    selectedCountryIso = getCountryIsoCodeByName(selectedCountry);
  }

  // Get country name for read-only mode
  const countryObj = allCountries.find((c) => c.isoCode === selectedCountryIso);
  const countryName = countryObj ? countryObj.name : selectedCountryIso;

  const isAnyRequiredFieldEmpty = requiredFields.some(
    (field) => !field.value || field.value.trim() === ""
  );

  const hasAnyError = requiredFields.some(
    (field) => field.error && field.error.trim() !== ""
  );
console.log("hasAnyError",hasAnyError)
console.log("isAnyRequiredFieldEmpty",isAnyRequiredFieldEmpty)
console.log("requiredFields",requiredFields)
  // Prepopulate states when country is already selected and states is empty
  useEffect(() => {
    if (
      selectedCountryIso &&
      Array.isArray(states) &&
      states.length === 0 &&
      typeof Country.getStatesOfCountry === "function"
    ) {
      const stateList = Country.getStatesOfCountry(selectedCountryIso);
      if (
        stateList &&
        stateList.length > 0 &&
        typeof setSponsorDetails === "function"
      ) {
        setSponsorDetails({
          ...sponsorDetails,
          states: stateList,
        });
      }
    }
  }, [selectedCountryIso, states, Country, setSponsorDetails, sponsorDetails]);

  // Modified handleNext function: just pass data up
  const handleNextWithUpdate = () => {
    handleNext({ sponsorDetails, adminDetails });
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.inline}>
            Sponsor Details
          </Typography>
          <hr className={classes.hrLine} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Sponsor Name
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {sponsorName || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              variant="outlined"
              className={classes.textfieldWidth}
              value={sponsorName}
              onChange={handleSponsorNameChange}
              onBlur={handleSponsorNameBlur}
              error={errors.sponsorName !== ""}
              helperText={errors.sponsorName}
              // onInput={(e) => {
              //   e.target.value = e.target.value
              //     .replace(/[^a-zA-Z0-9\s.,'’&()\[\]{}.-]/g, "")
              //     .replace(/\s{2,}/g, " ")
              //     .replace(/'{2,}/g, "'")
              //     .replace(/’{2,}/g, "’")
              //     .replace(/\.{2,}/g, ".")
              //     .replace(/&{2,}/g, "&")
              //     .replace(/-{2,}/g, "-")
              //     .replace(/,{2,}/g, ",");
              // }}
              //       onInput={(e) => {
              //   e.target.value = e.target.value
              //     .replace(/[^a-zA-Z\s&.,-]/g, "")   // allow only specific characters
              //     .replace(/\s{2,}/g, " ")           // replace multiple spaces with one
              //     .replace(/\.{2,}/g, ".")           // replace multiple dots with one
              //     .replace(/&{2,}/g, "&")            // replace multiple & with one
              //     .replace(/-{2,}/g, "-")            // replace multiple hyphens with one
              //     .replace(/,{2,}/g, ",");           // replace multiple commas with one
              // }}
              onInput={(e) => {
                e.target.value = e.target.value
    .replace(/[^a-zA-Z0-9\s\-.,\/()&:]/g, '')     // allow only valid characters
    .replace(/\s{2,}/g, ' ')                      // single space only
    .replace(/\.{2,}/g, '.')                      // single dot
    .replace(/&{2,}/g, '&')                       // single &
    .replace(/-{2,}/g, '-')                       // single hyphen
    .replace(/,{2,}/g, ',')                       // single comma
    .slice(0, 100);                                // max 30 characters
              }}
            />
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Sponsor Short Name
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {sponsorNameShortcut || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              variant="outlined"
              className={classes.textfieldWidth}
              value={sponsorNameShortcut}
              onChange={handleSponsorShortcutNameChange}
              onBlur={handleSponsorShortcutNameBlur}
              error={errors.sponsorNameShortcut !== ""}
              helperText={errors.sponsorNameShortcut}
              // onInput={(e) => {
              //   e.target.value = e.target.value
              //     .replace(/[^a-zA-Z0-9\s.,'’&()\[\]{}.-]/g, "")
              //     .replace(/\s{2,}/g, " ")
              //     .replace(/'{2,}/g, "'")
              //     .replace(/’{2,}/g, "’")
              //     .replace(/\.{2,}/g, ".")
              //     .replace(/&{2,}/g, "&")
              //     .replace(/-{2,}/g, "-")
              //     .replace(/,{2,}/g, ",");
              // }}
              onInput={(e) => {
                e.target.value = e.target.value
    .replace(/[^a-zA-Z\s&.,-]/g, "")   // allow only specific characters
    .replace(/\s{2,}/g, " ")           // replace multiple spaces with one
    .replace(/\.{2,}/g, ".")           // replace multiple dots with one
    .replace(/&{2,}/g, "&")            // replace multiple & with one
    .replace(/-{2,}/g, "-")            // replace multiple hyphens with one
    .replace(/,{2,}/g, ",");           // replace multiple commas with one
              }}
            />
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Street Address 1
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {streetAddress1 || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              variant="outlined"
              className={classes.textfieldWidth}
              value={`${streetAddress1}`}
              onChange={handleStreetAddress1Change}
              onBlur={handleStreetAddress1Blur}
              inputProps={{ maxLength: 255 }}
              error={errors.streetAddress1 !== ""}
              helperText={errors.streetAddress1}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^a-zA-Z0-9\s,.\-\/&]/g, "")
                  .replace(/(\s{2,}|,{2,}|\.{2,}|-{2,}|\/{2,}|&{2,})/g, "");
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Street Address 2
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {streetAddress2 || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              variant="outlined"
              className={classes.textfieldWidth}
              value={streetAddress2}
              onChange={handleStreetAddress2Change}
              onBlur={handleStreetAddress2Blur}
              error={errors.streetAddress2 !== ""}
              inputProps={{ maxLength: 255 }}
              helperText={errors.streetAddress2}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^a-zA-Z0-9\s,.\-\/&]/g, "")
                  .replace(/(\s{2,}|,{2,}|\.{2,}|-{2,}|\/{2,}|&{2,})/g, "");
              }}
            />
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Country
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {countryName || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              select
              variant="outlined"
              className={classes.textfieldWidth}
              value={selectedCountryIso ? selectedCountryIso : ""}
              onChange={handleCountryChange}
              error={errors.selectedCountry !== ""}
              helperText={errors.selectedCountry}
            >
              {allCountries.map((country) => (
                <MenuItem key={country.isoCode} value={country.isoCode}>
                  {country.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Grid>


        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            State
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {sponsorDetails.stateName || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              select
              variant="outlined"
              className={classes.textfieldWidth}
              value={selectedState}
              onChange={handleStateChange}
              error={errors.selectedState !== ""}
              helperText={errors.selectedState}
            >
              {states.length === 0 ? (
                <MenuItem disabled>No States Found</MenuItem>
              ) : (
                states.map((state) => (
                  <MenuItem key={state.isoCode} value={state.isoCode}>
                    {state.name}
                  </MenuItem>
                ))
              )}
            </TextField>
          )}
        </Grid>


        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            City
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {selectedCity || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              select
              variant="outlined"
              className={classes.textfieldWidth}
              value={selectedCity}
              onChange={handleCityChange}
              error={errors.selectedCity !== ""}
              helperText={errors.selectedCity}
            >
              {cities.length === 0 ? (
                <MenuItem disabled>No Cities Found</MenuItem>
              ) : (
                cities.map((city) => (
                  <MenuItem key={city.name} value={city.name}>
                    {city.name}
                  </MenuItem>
                ))
              )}
            </TextField>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Post Code
            {!existingSponsorFlow && (
              <span className={classes.required}>*</span>
            )}
          </Typography>
          {existingSponsorFlow ? (
            <Typography style={{ marginTop: "0.5rem" }}>
              {postCode || "NA"}
            </Typography>
          ) : (
            <TextField
              size="small"
              variant="outlined"
              className={classes.textfieldWidth}
              value={postCode}
              inputProps={{ maxLength: 12 }}
              onChange={handlePostCodeChange}
              onBlur={handlePostCodeBlur}
              error={errors.postCode !== ""}
              helperText={errors.postCode}
              onInput={(e) => {
                e.target.value = e.target.value
                 .replace(/[^0-9]/g, "");
              }}
            />
          )}
        </Grid>

        

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Status<span className={classes.required}>*</span>
          </Typography>

          {existingSponsorFlow === true ? (
            <TextField
              size="small"
              select
              variant="outlined"
              className={classes.textfieldWidth}
              onChange={handleStatusChange}
              value={selectedStatus}
              error={errors.selectedStatus !== ""}
              helperText={errors.selectedStatus}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>
          ) : (
            <TextField
              size="small"
              select
              variant="outlined"
              className={classes.textfieldWidth}
              onChange={handleStatusChange}
              value={selectedStatus}
              error={errors.selectedStatus !== ""}
              helperText={errors.selectedStatus}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {existingSponsorFlow && (
            <>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Organization Code
              </Typography>
              <Typography style={{ marginTop: "0.5rem" }}>
                {orgCode || "NA"}
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={11}>
          <hr className={classes.hr} />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.inline}>
            Admin Details
          </Typography>
          <hr className={classes.hrLine} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Full Name<span className={classes.required}>*</span>
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            className={classes.textfieldWidth}
            value={
              existingSponsorFlow ? adminDetails.fullName || "" : fullName || ""
            }
            onChange={handleFullNameChange}
            onBlur={handleFullNameBlur}
            error={errors.fullName !== ""}
            helperText={errors.fullName}
            onInput={(e) => {
              e.target.value = e.target.value
                .replace(/[^a-zA-Z\s']/g, "")
                .replace(/(\s{2,}|'{2,})/g, "");
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Email Address<span className={classes.required}>*</span>
          </Typography>

          {existingSponsorFlow ? (
            <TextField
              size="small"
              variant="outlined"
              className={classes.textfieldWidth}
              value={adminDetails?.emailAddress}
              onChange={handleEmailAddressChange}
              onBlur={handleEmailAddressBlur}
              error={errors.emailAddress !== ""}
              helperText={errors.emailAddress}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^a-zA-Z0-9@._%+-]/g, "")
                  .replace(/\.{2,}/g, ".");
              }}
            />
          ) : (
            <TextField
              size="small"
              variant="outlined"
              className={classes.textfieldWidth}
              value={emailAddress}
              onChange={handleEmailAddressChange}
              onBlur={handleEmailAddressBlur}
              error={errors.emailAddress !== ""}
              helperText={errors.emailAddress}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^a-zA-Z0-9@._%+-]/g, "")
                  .replace(/\.{2,}/g, ".");
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="body1"
            style={{ fontWeight: "bold", marginBottom: "8px" }}
          >
            Phone<span className={classes.required}>*</span>
          </Typography>

          {existingSponsorFlow ? (
            <>
              <PhoneInput
                country={adminDetails?.phone ? (adminDetails?.countryCode || "us").toLowerCase() : "us"}
                value={adminDetails?.phone || ""}
                onChange={handlePhoneChange}
                inputStyle={{
                  width: "80%",
                  height: "2.5rem",
                  borderColor: errors.phone ? "#f44336" : "#0000008a",
                }}
                isValid={!errors.phone}
                countryCodeEditable={true}
                enableSearch={true}
                searchPlaceholder="Search country..."
                searchNotFound="No country found"
              />
              <Typography
                variant="caption"
                style={{
                  margin: errors.phone ? "14px 14 4px 0" : "14px 14px 0 14px",
                  color: errors.phone ? "#f44336" : "#0000008a",
                  fontSize: "0.75rem",
                }}
              >
                {errors.phone}
              </Typography>
            </>
          ) : (
            <>
              <PhoneInput
                // country={adminDetails?.phone ? (adminDetails?.countryCode || "us").toLowerCase() : "us"}
                value={adminDetails?.phone || ""}
                onChange={handlePhoneChange}
                inputStyle={{
                  width: "80%",
                  height: "2.5rem",
                  borderColor: errors.phone ? "#f44336" : "#0000008a",
                }}
                isValid={!errors.phone}
                countryCodeEditable={true}
                enableSearch={true}
                searchPlaceholder="Search country..."
                searchNotFound="No country found"
              />
              <Typography
                variant="caption"
                style={{
                  margin: errors.phone ? "14px 14 4px 0" : "14px 14px 0 14px",
                  color: errors.phone ? "#f44336" : "#0000008a",
                  fontSize: "0.75rem",
                }}
              >
                {errors.phone}
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography>
            <span style={{ fontWeight: "500" }}>Note: </span>All fields marked
            with an asterisk (<span style={{ color: "red" }}>*</span>) are
            mandatory.
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >          <Button
            variant="contained"
            color="primary"
            endIcon={!sponsorDetailsLoading && <ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
              marginRight: "7rem",
            }}
            onClick={handleNextWithUpdate}
            disabled={isAnyRequiredFieldEmpty || hasAnyError || sponsorDetailsLoading}
          >
            {sponsorDetailsLoading ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={20} color="inherit" style={{ marginRight: "8px" }} />
                Processing...
              </div>
            ) : (
              "Save & Next"
            )}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default SponsorDetails;
